import { useState, useRef, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import {
  FaBell,
  FaUserCircle,
  FaUser,
  FaKey,
  FaCog,
  FaSignOutAlt
} from "react-icons/fa";

function Navbar() {

  const navigate = useNavigate();

  const [open, setOpen] = useState(false);

  const dropdownRef = useRef(null);

  const admin =
    JSON.parse(localStorage.getItem("user")) ||
    JSON.parse(localStorage.getItem("adminInfo")) || {
      name: "Administrator"
    };

  const today = new Date().toLocaleDateString("en-IN", {
    weekday: "long",
    day: "numeric",
    month: "long",
    year: "numeric",
  });

  useEffect(() => {

    function handleClickOutside(event) {

      if (
        dropdownRef.current &&
        !dropdownRef.current.contains(event.target)
      ) {
        setOpen(false);
      }

    }

    document.addEventListener("mousedown", handleClickOutside);

    return () =>
      document.removeEventListener(
        "mousedown",
        handleClickOutside
      );

  }, []);

const logout = () => {

    localStorage.clear();

    window.location.href = "/admin/login";

};
  return (
    <div className="bg-white shadow-sm border-b px-8 py-5 flex items-center justify-between">

      {/* Left */}

      <div>

        <h1 className="text-3xl font-bold text-gray-800">
          Welcome Back 👋
        </h1>

        <p className="text-gray-500 mt-1">
          {today}
        </p>

      </div>

      {/* Right */}

      <div className="flex items-center gap-6">

        {/* Notification */}

        <button className="relative bg-gray-100 hover:bg-gray-200 transition p-3 rounded-xl">

          <FaBell
            size={20}
            className="text-gray-700"
          />

          <span className="absolute -top-1 -right-1 w-3 h-3 rounded-full bg-red-500"></span>

        </button>

        {/* Profile */}

        <div
          className="relative"
          ref={dropdownRef}
        >

          <div
            onClick={() => setOpen(!open)}
            className="flex items-center gap-3 bg-gray-100 px-4 py-2 rounded-2xl cursor-pointer hover:bg-gray-200 transition"
          >

            <FaUserCircle
              size={42}
              className="text-teal-700"
            />

            <div>

              <h3 className="font-semibold text-gray-800">
                {admin.name}
              </h3>

              <p className="text-sm text-gray-500">
                Super Admin
              </p>

            </div>

          </div>

          {open && (

            <div className="absolute right-0 mt-3 w-60 bg-white rounded-xl shadow-xl border z-50">

              <button
                onClick={() => {
                  navigate("/admin/profile");
                  setOpen(false);
                }}
                className="w-full flex items-center gap-3 px-5 py-3 hover:bg-gray-100"
              >
                <FaUser />
                My Profile
              </button>

              <button
                onClick={() => {
                  navigate("/admin/profile");
                  setOpen(false);
                }}
                className="w-full flex items-center gap-3 px-5 py-3 hover:bg-gray-100"
              >
                <FaKey />
                Change Password
              </button>

              <button
                onClick={() => {
                  navigate("/admin/settings");
                  setOpen(false);
                }}
                className="w-full flex items-center gap-3 px-5 py-3 hover:bg-gray-100"
              >
                <FaCog />
                Settings
              </button>

              <hr />

              <button
                onClick={logout}
                className="w-full flex items-center gap-3 px-5 py-3 text-red-600 hover:bg-red-50"
              >
                <FaSignOutAlt />
                Logout
              </button>

            </div>

          )}

        </div>

      </div>

    </div>
  );

}

export default Navbar;